import { login, logout, getUserInfo, getPermissions } from '@/api/login'
import {
  setUnify,
  getToken,
  setToken,
  removeToken,
  setMyToken,
  removeMyToken,
  removeUnify,
  setUserRoles,
  removeUserRoles,
  getCharger,
  setCharger
} from '@/utils/auth'
import { getUnify } from '../../utils/auth'
import store from '@/store'

const loginInfo = async (data, commit, dispatch) => {
  const { authorization, currentAgency, jwtUser, userAgencys } = data

  commit('SET_TOKEN', authorization)

  commit('SET_ROLES', currentAgency.permissions)
  setUserRoles(currentAgency.permissions)
  setUnify(authorization)
  setToken(authorization)
  setCharger(jwtUser.name)
  // setCharger(jwtUser.name)
  // setOrganizationList(userAgencys)
  localStorage.setItem('userId', jwtUser.userId)
  localStorage.setItem('userInfo', JSON.stringify(jwtUser))

  // await dispatch('getUserPermissions')
}
const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: '',
    name: '',
    avatar: '',
    introduction: '管理员',
    roles: null,
    setting: {
      articlePlatform: []
    },

    myToken: '',
    sidebarLogo: true
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_MY_TOKEN: (state, token) => {
      state.myToken = token
    }
  },

  actions: {
    login({ commit, dispatch, state }, userInfo) {
      const { userName, password } = userInfo
      return new Promise((resolve, reject) => {
        login({ userName: userName.trim(), password })
          .then(async data => {
            //判断是否需要改密码
            if (!data.needUpdatePassword) {
              await loginInfo(data, commit, dispatch)
              resolve(data)
            } else {
              resolve(data)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取用户权限和用户信息
    getUserPermissions({ commit, state }) {
      return new Promise((resolve, reject) => {
        getPermissions({})
          .then(data => {
            commit('SET_ROLES', data)
            setUserRoles(data)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        console.log(resolve)
        // commit('SET_ROLES', ['admin'])
        resolve(resolve)
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout({
          data: {},
          success: res => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            removeUnify()
            removeMyToken()
            removeUserRoles()
            resolve()
          },
          error: err => {
            reject(err)
          }
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        removeMyToken()
        removeUnify()
        removeUserRoles()
        commit('setTodoPolling', null) //清空打印任务轮询
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles({ commit, dispatch }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          setCharger(data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          dispatch('generateRoutes', data) // 动态修改权限后 重绘侧边菜单
          resolve()
        })
      })
    }
  }
}

export default user
